import React from 'react';

import VideoToCanvas from './VideoToCanvas';

class ForensicVideoPlayer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            play: true,
            data: props.frameData,
            url: props.url,
            videoSrc: props.url, paused: false
        }
    }

    componentWillReceiveProps(nProps) {
        this.setState({
            url: nProps.url,
            data: nProps.frameData,
            videoSrc: nProps.url, paused: false
        })
    }


    render() {

        return (
            <div className="forensic-player"  >
                <VideoToCanvas src={this.state.videoSrc} width={800} height={440}
                    fps={this.props.info?.metadata?.video?.frame_rate}
                    frames={this.state.data.frames}
                    resultInfo={this.state.data.result_info}
                    frameWidth={this.props.info?.metadata?.video?.width}
                    frameHeight={this.props.info?.metadata?.video?.height}
                />
            </div>
        )
    }
};

export default ForensicVideoPlayer;
